import { Space, Statistic } from 'antd'
import { useEffect, useState } from 'react'
import { SBAPIFetch } from '../../helpers/SBAPIHelper'
import { ANALYTICS_URL } from '../../helpers/urls'
import { readRateFormatter } from '../../helpers/formatters'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { AnswerAnalytics } from '../../models/Answer'

interface Props {
  id?: string
}

const Analytics = ({ id }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [count, setCount] = useState<AnswerAnalytics | undefined>(undefined)

  useEffect(() => {
    setIsLoading(true)
    const url = `${ANALYTICS_URL}/answers`
    SBAPIFetch<AnswerAnalytics>(url + (id ? `/${id}` : ''))
      .then((response) => {
        setCount(response.data)
      })
      .finally(() => setIsLoading(false))
  }, [id])

  return (
    <Space size={20}>
      <Statistic
        loading={isLoading}
        title={i18n.t(LocalizationKeys.Component.Answer.Analytics.TotalSent)}
        value={count?.sent}
      />
      <Statistic
        loading={isLoading}
        title={i18n.t(LocalizationKeys.Component.Answer.Analytics.OpeningRate)}
        value={readRateFormatter(count?.sent, count?.read)}
        suffix={'%'}
      />
    </Space>
  )
}

type AnalyticsType = { Analytics: typeof Analytics }

export { Analytics, type AnalyticsType }
